/**
 * Created by henian.xu on 2019/12/26.
 *
 */

/* eslint-disable func-names */
/* eslint-disable no-alert */

import { Vue, Utils } from 'vmf';
import { QWebChannel } from './qwebchannel';

const defaultStateData = JSON.stringify({
    dialog: null,
    scanSize: [
        { label: '原始尺寸', id: 'setScanSize_ori' },
        { label: 'A5', id: 'setScanSize_A5' },
        { label: 'A4', id: 'setScanSize_A4' },
        { label: '卡片', id: 'setScanSize_card' },
        // add
    ], // 设置尺寸 这个是自定的
    bigPriDev: '',
    bigSubDev: '',
    priDevName: '', // 设备名
    priModel: [], // 主头设备出图格式
    priResolution: [], // 主头设备分辨率
    subDevName: '', // 设备名
    subModel: [], // 副头设备出图格式
    subResolution: [], // 副头设备分辨率
    serialNumber: '', // 后台程序返回设备序列号
    barcodeInfo: '', // 后台程序条形码、二维码识别结果
    photographHistory: [],
});

export const state = Vue.observable(JSON.parse(defaultStateData));
const baseUrl = 'ws://127.0.0.1:12345';
let socket = null;

// 储存图片路径的变量和数组
let imgPath = '';
let openPromise = null;
let closeResolve = null;
const priPhotographResolveQueue = [];
const subPhotographResolveQueue = [];

// 增加图片缩略图
/* function addImgDiv() {
    var container = document.getElementById('container');
    var newchild = document.createElement('div');
    newchild.setAttribute('style', 'float:left');
    imgPath = 'file:///' + imgPath;
    newchild.setAttribute('id', imgPath);
    imgPathArray.push(imgPath); ////增加缩略图时默认把路径加入图片数组
    newchild.innerHTML =
        "<img width='105' height='85' src='" +
        imgPath +
        "' onclick='openImage(this)' /></img><input type='checkbox' checked='checked' onchange='checkboxClicked(this)' />";
    container.appendChild(newchild);
} */
function buildFile(message) {
    const binStr = atob(message);
    const arr = new Uint8Array(binStr.length);
    for (let i = 0; i < binStr.length; i += 1) {
        arr[i] = binStr.charCodeAt(i);
    }
    const uniqueId = `${Utils.getUniqueId('fileName-')}.jpg`;
    const file = new File([arr], uniqueId, { type: 'jpg' });
    let blob = null;
    if (URL && URL.createObjectURL) {
        blob = URL.createObjectURL(file);
    }
    const res = {
        id: uniqueId,
        selected: true,
        progress: 0,
        status: '',
        error: '',
        response: null,
        // base64: `data:image/png;base64,${message}`,
        file,
        blob,
    };
    state.photographHistory.push(res);
    return res;
}

// 清空缩略图
function removeAll() {}

export async function close() {
    state.dialog.get_actionType('closeSignal');
    socket.close();
    const stateData = JSON.parse(defaultStateData);
    Object.keys(stateData).forEach(key => {
        state[key] = stateData[key];
    });
    console.log(state);
    return new Promise(resolve => {
        closeResolve = resolve;
    });
}

function openSocket() {
    socket = new WebSocket(baseUrl);
    socket.onclose = function() {
        console.error('web channel closed');
        if (closeResolve) {
            closeResolve();
            closeResolve = null;
        }
    };
    socket.onerror = function(error) {
        console.error(`web channel error: ${error}`);
        if (openPromise) {
            try {
                if (state.dialog) state.dialog.get_actionType('closeSignal');
                socket.close();
            } catch (e) {
                console.log(e);
            }
            openPromise.reject('未安装高拍仪设备。');
        }
    };
    socket.onopen = function() {
        console.log('WebSocket connected');
        // eslint-disable-next-line no-new
        new QWebChannel(socket, function(channel) {
            // 获取注册的对象
            state.dialog = channel.objects.dialog;
            const { dialog } = state;
            // 网页关闭函数
            window.addEventListener('beforeunload', close);
            window.addEventListener('unload', close);

            state.priResolution = [];
            // 服务器返回消息
            dialog.sendPrintInfo.connect(function(message) {
                // 读取二代证头像返回信息
                let value;
                if (message.indexOf('idFaceInfo:') >= 0) {
                    value = message.substr(11);
                    const element = document.getElementById('devPhoto2');
                    element.src = `data:image/jpg;base64,${value}`;
                    return;
                }
                // 获取文件base64返回值
                if (message.indexOf('fileBase64:') >= 0) {
                    value = message.substr(11);
                    alert(value);
                    return;
                }
                // 未安装驱动
                if (message.indexOf('No equipment found') >= 0) {
                    if (openPromise) {
                        state.dialog.get_actionType('closeSignal');
                        socket.close();
                        openPromise.reject('未链接高拍仪设备。');
                        return;
                    }
                }
                // console.log(message);

                /** ******主头设备信息********** */
                // 设备名
                let img;
                let name;
                if (message.indexOf('priDevName:') >= 0) {
                    message = message.substr(11);
                    state.priDevName = message;
                }
                // 主头设备出图格式
                else if (message.indexOf('priModel:') >= 0) {
                    message = message.substr(9);
                    if (message.indexOf('MJPG') >= 0) {
                        state.priModel.unshift(message);
                    } else {
                        state.priModel.push(message);
                    }
                }
                // 主头设备分辨率
                else if (message.indexOf('priResolution:') >= 0) {
                    message = message.substr(14);
                    state.priResolution.push(message);
                }
                /** ******副头设备信息********** */
                // 设备名
                else if (message.indexOf('subDevName:') >= 0) {
                    message = message.substr(11);
                    state.subDevName = message;
                }
                // 副头设备出图格式
                else if (message.indexOf('subModel:') >= 0) {
                    message = message.substr(9);
                    if (message.indexOf('MJPG') >= 0) {
                        state.subModel.unshift(message);
                    } else {
                        state.subModel.push(message);
                    }
                }
                // 副头设备分辨率
                else if (message.indexOf('subResolution:') >= 0) {
                    message = message.substr(14);
                    state.subResolution.push(message);
                }
                // 后台程序返回设备序列号
                else if (message.indexOf('SerialNumber:') >= 0) {
                    state.serialNumber = message.substr(13);
                }
                // 后台程序条形码、二维码识别结果
                else if (message.indexOf('BarcodeInfo:') >= 0) {
                    // 格式为 "BarcodeInfo:" + "个数\n" + "识别结果\n"。每个每个结果后有换行符
                    state.barcodeInfo = message.substr(12);
                }
                // 图片保存后返回路径关键字savePhoto_success:
                else if (message.indexOf('savePhoto_success:') >= 0) {
                    imgPath = message.substr(18);
                    console.log(imgPath);
                    // addImgDiv();
                }
                // 合成pdf成功，返回路径关键字composePDF_success:
                else if (message.indexOf('composePDF_success:') >= 0) {
                    const path = message.substr(19);
                    removeAll();
                    console.log(path);
                }
                // 指纹特征数据返回
                if (message.indexOf('GetBiokeyFeature_success!') >= 0) {
                    img = document.getElementById('BiokeyImg1');
                    name = message.substr(25);
                    // img.src = "file:///d:\\BiokeyImg1.jpg" +'?'+ Math.random();
                    img.src = `${name}?${Math.random()}`;
                }
                // 指纹模板数据返回
                if (message.indexOf('GetBiokeyTemplate_success!') >= 0) {
                    img = document.getElementById('BiokeyImg2');
                    name = message.substr(26);
                    // img.src = "file:///d:\\BiokeyImg2.jpg" +'?'+ Math.random();
                    img.src = `${name}?${Math.random()}`;
                }

                if (openPromise) {
                    openPromise.resolve();
                    openPromise = null;
                }
            });
            // 接收图片流用来展示，多个，较小的base64，主头数据
            dialog.send_priImgData.connect(function(message) {
                // var element = document.getElementById('bigPriDev');
                // element.src = 'data:image/jpg;base64,' + message;
                state.bigPriDev = `data:image/jpg;base64,${message}`;
            });
            // 接收图片流用来展示，多个，较小的base64，副头数据
            dialog.send_subImgData.connect(function(message) {
                // var element = document.getElementById('bigSubDev');
                // element.src = 'data:image/jpg;base64,' + message;
                state.bigSubDev = `data:image/jpg;base64,${message}`;
            });

            // 接收拍照base64，主头数据
            dialog.send_priPhotoData.connect(function(message) {
                /* var element = document.getElementById('devPhoto');
                element.src = 'data:image/jpg;base64,' + message; */
                const resolve = priPhotographResolveQueue.shift();
                if (!resolve) return;
                resolve(buildFile(message));
            });
            // 接收拍照base64，副头数据
            dialog.send_subPhotoData.connect(function(message) {
                // var element = document.getElementById('devPhoto2');
                // element.src = 'data:image/jpg;base64,' + message;
                const resolve = subPhotographResolveQueue.shift();
                if (!resolve) return;
                resolve(buildFile(message));
            });

            console.log('ready to send/receive messages!');
            // 网页加载完成信号
            // dialog.html_loaded("two");
            // dialog.html_loaded('faceDetect_two');
            dialog.html_loaded('two');

            // 设置图片dpi，第二个参数是dpi大小
            dialog.get_functionTypes('setImageProperty', '300', '', '');
        });
    };
}

export async function open() {
    console.log(`Connecting at ${baseUrl}.`);
    const promise = new Promise((resolve, reject) => {
        openPromise = { resolve, reject };
    });
    openSocket();
    return promise;
}

export async function priPhotograph() {
    state.dialog.photoBtnClicked('primaryDev_');
    state.dialog.get_actionType('savePhotoPriDev');
    return new Promise(resolve => priPhotographResolveQueue.push(resolve));
}
export async function subPhotograph() {
    state.dialog.photoBtnClicked('subDev_');
    state.dialog.get_actionType('savePhotoSubDev');
    return new Promise(resolve => subPhotographResolveQueue.push(resolve));
}
export function setPriScanSize(value) {
    if (!value) return;
    state.dialog.get_actionType(value);
}
export function setPriResolution(value) {
    if (!value) return;
    state.dialog.devChanged(`primaryDev_:${value}`);
}
export function setdeskew(value) {
    console.log(value);
    state.dialog.get_actionType('setdeskew');
}
export function showProperty() {
    state.dialog.get_actionType('showProperty');
}
